<template>
  <div class="image-container">
    <i  class="full-screen-button fas fa-expand" @click="toggleFullScreenMode($event)"></i>
    <viewer :test="true" :images="[imageUrl]" :options="viewerOptions">
      <img class="preview-image" :key="imageUrl" :src="imageUrl">
    </viewer>
  </div>
</template>

<script>
import 'viewerjs/dist/viewer.css'
import {component as Viewer} from "v-viewer"
import firebase from "firebase/app";
import '@/assets/css/imageViewer.css';

export default {
  name: "ImageViewer",
  props: ['imageFile'],
  data() {
    return {
      imageUrl: '',
      viewerOptions: {
        "inline": false,
        "button": true,
        "navbar": false,
        "title": false,
        "toolbar": true,
        "tooltip": true,
        "movable": true,
        "zoomable": true,
        "rotatable": true,
        "scalable": true,
        "transition": true,
        "fullscreen": true,
        "keyboard": true
      }
    }
  },
  components: {
    Viewer
  },
  methods: {
    toggleFullScreenMode($event) {
      // Go 1 level up (path element 0 = the clicked button, element 1 = the parent)
      // Then go down again to the second child (no. 1 => the image container)
      // Then get the first child (img) and trigger the click
      $event.path[1].children[1].children[0].click()
    },
    async getFileUrl() {
      // Three ways of providing a file
      // 1: a file containing an url
      // 2: a file without url but a firebase path
      // 3: a local file from a file selector
      if (!this.imageFile.file && this.imageFile.url) {
        this.imageUrl = this.imageFile.url;
      } else if (!this.imageFile.file) {
        this.imageUrl = await this.getDownloadURLFromBucket(this.imageFile.fullPath)
      } else {
        const reader = new FileReader();
        reader.readAsDataURL(this.imageFile.file);
        reader.onload = (e) => {
          this.imageUrl = e.target.result;
        };
      }
    },
    async getDownloadURLFromBucket(path) {
      const fileRef = firebase
          .storage()
          .ref(`${path}`);
      return fileRef.getDownloadURL();
    }
  },
  created() {
    this.getFileUrl();
  },
  watch: {
    imageFile: {
      deep: true,
      handler() {
        this.getFileUrl();
      }
    }
  }
}
</script>

<style scoped>
.image-container {
  border: 1px solid #00c9ff;
  background-color: silver;
  text-align: center;
  max-height: inherit;
}

.preview-image {
  max-height: inherit;
  max-width: 100%;
  padding: 3px;
}

.image-container {
  display: grid;
  align-content: center;
}

.image-container {
  height: 100%;
  max-width: 100%;
}

.image-container > div {
  max-width: 100%;
  max-height: inherit;
}

.full-screen-button {
  position: absolute;
  right: 120px;
  margin-top: 5rem;
  width: auto;
  z-index: 999;
  cursor: pointer;
  font-size: 25px;
  color: #00c9ff;
  text-shadow: 1px 2px rgba(0,0, 0, 0.4);
}
</style>